import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Bed, Bath, Car, Ruler, MapPin, PlayCircle, ArrowRight } from "lucide-react";
import { virtualTours, img } from "../mock";
import Seo from "../components/Seo";

const VirtualTours = () => {
  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.1 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Seo
        title="Virtual Tours"
        description="Tour Monarch Homes model designs - The Abacos, Jessie, Katie II, Villa Verde and Florentina. Explore our award-winning custom home floor plans on the Space Coast."
        keywords="Monarch Homes model tours, custom home floor plans Brevard County, Abacos model Melbourne FL"
        path="/virtual-tours"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.ext3})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Virtual Tours</div>
          <h1>Virtual Tours</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Explore Our Models</div>
            <h2>Tour Our Award-Winning Designs</h2>
            <p>Step inside our model homes and floor plans from the comfort of your own home. Request a private walkthrough of any design below.</p>
            <div className="mh-divider" />
          </div>

          <div className="mh-grid-3">
            {virtualTours.map((t, i) => (
              <div key={i} className="mh-home-card mh-reveal">
                <div className="mh-home-media mh-tour-media">
                  <img src={t.image} alt={t.name} loading="lazy" />
                  <div className="mh-tour-play"><PlayCircle size={54} /></div>
                </div>
                <div className="mh-home-body">
                  <h3>{t.name}</h3>
                  <div className="mh-home-addr"><MapPin size={15} /> {t.community}</div>
                  <p className="mh-home-desc">{t.desc}</p>
                  <div className="mh-specs">
                    <span className="mh-spec"><Bed size={14} /> {t.beds}</span>
                    <span className="mh-spec"><Bath size={14} /> {t.baths}</span>
                    <span className="mh-spec"><Car size={14} /> {t.garage}</span>
                    <span className="mh-spec"><Ruler size={14} /> {t.sqft} sq.ft.</span>
                  </div>
                  <div className="mh-home-foot">
                    <Link to="/contact" className="mh-cta-btn" style={{ padding: "9px 18px", fontSize: 13 }}>Request A Tour <ArrowRight size={15} /></Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default VirtualTours;
